import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoForklift = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Forklift</title>
    <path
      d="M5.599 23.27H4.342V10.7h5.656l4.4 6.285h5.028v3.143m-6.914 3.142h3.771"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.426 20.756v-3.771L17.541 6.928H9.999V10.7M19.428 27.043a3.143 3.143 0 1 0 0-6.286 3.143 3.143 0 0 0 0 6.286Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22.57 6.928V23.27h8.8" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path
      d="M9.37 27.042a3.143 3.143 0 1 0 0-6.286 3.143 3.143 0 0 0 0 6.286Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoForklift;
